export const actInstallsData = [
  {
    "name": "Acton",
    "value": 12,
    "lat": -35.2852323,
    "lng": 149.1129681
  },
  {
    "name": "Acton Peninsula",
    "value": 1,
    "lat": -35.2900563,
    "lng": 149.1173851
  },
  {
    "name": "Ainslie",
    "value": 9,
    "lat": -35.2621952,
    "lng": 149.14788
  },
  {
    "name": "Amaroo",
    "value": 12,
    "lat": -35.169587,
    "lng": 149.1280212
  },
  {
    "name": "Aranda",
    "value": 4,
    "lat": -35.2580548,
    "lng": 149.0804262
  },
  {
    "name": "Barton",
    "value": 12,
    "lat": -35.3072631,
    "lng": 149.1404986
  },
  {
    "name": "Beard",
    "value": 1,
    "lat": -35.3418055,
    "lng": 149.2100977
  },
  {
    "name": "Bega",
    "value": 1,
    "lat": -35.32614,
    "lng": 149.1505252
  },
  {
    "name": "Belconnen",
    "value": 4,
    "lat": -35.2274338,
    "lng": 149.0431454
  },
  {
    "name": "Bonner",
    "value": 1,
    "lat": -35.1559621,
    "lng": 149.1429557
  },
  {
    "name": "Braddon",
    "value": 9,
    "lat": -35.2708149,
    "lng": 149.135735
  },
  {
    "name": "Braidwood",
    "value": 1,
    "lat": -35.4883502,
    "lng": 149.0026942
  },
  {
    "name": "Bruce",
    "value": 13,
    "lat": -35.2453517,
    "lng": 149.0916334
  },
  {
    "name": "Bungendore",
    "value": 5,
    "lat": -35.4883502,
    "lng": 149.0026942
  },
  {
    "name": "Cabramurra",
    "value": 4,
    "lat": -35.4883502,
    "lng": 149.0026942
  },
  {
    "name": "Calwell",
    "value": 3,
    "lat": -35.4403858,
    "lng": 149.1071069
  },
  {
    "name": "Campbell",
    "value": 28,
    "lat": -35.28059825,
    "lng": 149.14932371073422
  },
  {
    "name": "Canberra",
    "value": 43,
    "lat": -35.2975906,
    "lng": 149.1012676
  },
  {
    "name": "Canberra Airport",
    "value": 12,
    "lat": -35.304391,
    "lng": 149.1936903
  },
  {
    "name": "Canberra City",
    "value": 2,
    "lat": -35.283662750000005,
    "lng": 149.12310149852618
  },
  {
    "name": "Carwoola",
    "value": 1,
    "lat": -35.23187685,
    "lng": 149.06091051978927
  },
  {
    "name": "Charnwood",
    "value": 2,
    "lat": -35.2001777,
    "lng": 149.0341356
  },
  {
    "name": "Chifley",
    "value": 1,
    "lat": -35.3532951,
    "lng": 149.0768898
  },
  {
    "name": "Chisholm",
    "value": 3,
    "lat": -35.4219655,
    "lng": 149.1248452
  },
  {
    "name": "Conder",
    "value": 4,
    "lat": -35.4592733,
    "lng": 149.1043282
  },
  {
    "name": "Cook",
    "value": 1,
    "lat": -35.2601034,
    "lng": 149.0663657
  },
  {
    "name": "Cooma",
    "value": 1,
    "lat": -35.500106771889136,
    "lng": 149.15072399035725
  },
  {
    "name": "Coombs",
    "value": 1,
    "lat": -35.3167344,
    "lng": 149.0425254
  },
  {
    "name": "Curtin",
    "value": 6,
    "lat": -35.3246324,
    "lng": 149.0773776
  },
  {
    "name": "Deakin",
    "value": 9,
    "lat": -35.318898,
    "lng": 149.0930095748252
  },
  {
    "name": "Denman",
    "value": 1,
    "lat": -35.29457575,
    "lng": 149.02702410915066
  },
  {
    "name": "Denman Prospect",
    "value": 30,
    "lat": -35.29457575,
    "lng": 149.02702410915066
  },
  {
    "name": "Dickson",
    "value": 13,
    "lat": -35.2527861,
    "lng": 149.1417216
  },
  {
    "name": "Downer",
    "value": 4,
    "lat": -35.2438315,
    "lng": 149.1435455
  },
  {
    "name": "Duffy",
    "value": 3,
    "lat": -35.3345516,
    "lng": 149.0318996
  },
  {
    "name": "Dunlop",
    "value": 1,
    "lat": -35.1939974,
    "lng": 149.0198014
  },
  {
    "name": "Duntroon",
    "value": 1,
    "lat": -35.297689,
    "lng": 149.1664644
  },
  {
    "name": "EPIC",
    "value": 2,
    "lat": -35.2286339,
    "lng": 149.1443131
  },
  {
    "name": "Environa",
    "value": 1,
    "lat": -35.4883502,
    "lng": 149.0026942
  },
  {
    "name": "Evatt",
    "value": 5,
    "lat": -35.211832,
    "lng": 149.068948
  },
  {
    "name": "Fairbairn",
    "value": 2,
    "lat": -35.310546200000005,
    "lng": 149.22573891224786
  },
  {
    "name": "Farrer",
    "value": 5,
    "lat": -35.3766895,
    "lng": 149.1050381
  },
  {
    "name": "Florey",
    "value": 2,
    "lat": -35.2257904,
    "lng": 149.0501748
  },
  {
    "name": "Flynn",
    "value": 1,
    "lat": -35.2058369,
    "lng": 149.0440634
  },
  {
    "name": "Forde",
    "value": 3,
    "lat": -35.168224,
    "lng": 149.1460688
  },
  {
    "name": "Forrest",
    "value": 4,
    "lat": -35.3172087,
    "lng": 149.1248559
  },
  {
    "name": "Franklin",
    "value": 1,
    "lat": -35.485283,
    "lng": 148.7761701
  },
  {
    "name": "Fyshwick",
    "value": 9,
    "lat": -35.3216575,
    "lng": 149.1708774
  },
  {
    "name": "Garran",
    "value": 6,
    "lat": -35.3413973,
    "lng": 149.1085392
  },
  {
    "name": "Garren",
    "value": 1,
    "lat": -35.4883502,
    "lng": 149.0026942
  },
  {
    "name": "Gilmore",
    "value": 1,
    "lat": -35.4150113,
    "lng": 149.1382782
  },
  {
    "name": "Googong",
    "value": 7,
    "lat": -35.4883502,
    "lng": 149.0026942
  },
  {
    "name": "Gordon",
    "value": 5,
    "lat": -35.4567263,
    "lng": 149.0850656
  },
  {
    "name": "Goulburn",
    "value": 4,
    "lat": -35.2512117,
    "lng": 149.0622042
  },
  {
    "name": "Gowrie",
    "value": 1,
    "lat": -35.4118165,
    "lng": 149.1091063
  },
  {
    "name": "Greenway",
    "value": 2,
    "lat": -35.4158082,
    "lng": 149.0648149
  },
  {
    "name": "Griffith",
    "value": 9,
    "lat": -35.3253499,
    "lng": 149.1371297
  },
  {
    "name": "Gundagai",
    "value": 1,
    "lat": -35.4883502,
    "lng": 149.0026942
  },
  {
    "name": "Gungahlin",
    "value": 10,
    "lat": -35.1788782,
    "lng": 149.123653
  },
  {
    "name": "Hackett",
    "value": 3,
    "lat": -35.2495093,
    "lng": 149.1635441
  },
  {
    "name": "Harman",
    "value": 8,
    "lat": -35.3484816,
    "lng": 149.19978283677278
  },
  {
    "name": "Harrison",
    "value": 1,
    "lat": -35.1990601,
    "lng": 149.1561261
  },
  {
    "name": "Hawker",
    "value": 1,
    "lat": -35.2470444,
    "lng": 149.0366967
  },
  {
    "name": "Holder",
    "value": 1,
    "lat": -35.3344827,
    "lng": 149.0461678
  },
  {
    "name": "Holt",
    "value": 10,
    "lat": -35.2243961,
    "lng": 149.0119295
  },
  {
    "name": "Hughes",
    "value": 4,
    "lat": -35.3326252,
    "lng": 149.0949433
  },
  {
    "name": "Hume",
    "value": 8,
    "lat": -35.3853817,
    "lng": 149.1658468
  },
  {
    "name": "Isabella Plains",
    "value": 1,
    "lat": -35.4280072,
    "lng": 149.0940088
  },
  {
    "name": "Jacka",
    "value": 15,
    "lat": -35.1495163,
    "lng": 149.1304298
  },
  {
    "name": "Jacka/taylor",
    "value": 1,
    "lat": -35.1495163,
    "lng": 149.1304298
  },
  {
    "name": "Jerrabomberra",
    "value": 4,
    "lat": -35.3644859,
    "lng": 149.1620421
  },
  {
    "name": "Jindabyne",
    "value": 1,
    "lat": -35.40109525,
    "lng": 149.0856639759062
  },
  {
    "name": "Kaleen",
    "value": 7,
    "lat": -35.2277875,
    "lng": 149.1091388
  },
  {
    "name": "Kambah",
    "value": 13,
    "lat": -35.3862287,
    "lng": 149.0579669
  },
  {
    "name": "Karabar",
    "value": 2,
    "lat": -35.4883502,
    "lng": 149.0026942
  },
  {
    "name": "Kenny",
    "value": 2,
    "lat": -35.215413299999994,
    "lng": 149.1648360653991
  },
  {
    "name": "Kingston",
    "value": 10,
    "lat": -35.3152303,
    "lng": 149.1465925
  },
  {
    "name": "Latham",
    "value": 2,
    "lat": -35.2163913,
    "lng": 149.0316392
  },
  {
    "name": "Lawson",
    "value": 3,
    "lat": -35.224992,
    "lng": 149.0881795
  },
  {
    "name": "Lyneham",
    "value": 11,
    "lat": -35.239801,
    "lng": 149.1307354
  },
  {
    "name": "Lynhem",
    "value": 1,
    "lat": -35.4883502,
    "lng": 149.0026942
  },
  {
    "name": "Lyons",
    "value": 3,
    "lat": -35.3405584,
    "lng": 149.0739377
  },
  {
    "name": "Macarthur",
    "value": 1,
    "lat": -35.4051323,
    "lng": 149.1316729
  },
  {
    "name": "Macgregor",
    "value": 3,
    "lat": -35.2097738,
    "lng": 149.0110215
  },
  {
    "name": "Macnamara",
    "value": 29,
    "lat": -35.2186569,
    "lng": 148.9764412
  },
  {
    "name": "Macquarie",
    "value": 5,
    "lat": -35.2511133,
    "lng": 149.0633056
  },
  {
    "name": "Majura",
    "value": 5,
    "lat": -35.2751243,
    "lng": 149.2101716
  },
  {
    "name": "Marulan",
    "value": 1,
    "lat": -35.4883502,
    "lng": 149.0026942
  },
  {
    "name": "McKellar",
    "value": 3,
    "lat": -35.2146983,
    "lng": 149.0842712
  },
  {
    "name": "Michelago",
    "value": 1,
    "lat": -35.4883502,
    "lng": 149.0026942
  },
  {
    "name": "Mitchell",
    "value": 14,
    "lat": -35.2188934,
    "lng": 149.1363833
  },
  {
    "name": "Monash",
    "value": 4,
    "lat": -35.4157378,
    "lng": 149.0906903
  },
  {
    "name": "Moncrieff",
    "value": 3,
    "lat": -35.158821,
    "lng": 149.1163057
  },
  {
    "name": "Murrumbateman",
    "value": 1,
    "lat": -35.4883502,
    "lng": 149.0026942
  },
  {
    "name": "Narrabundah",
    "value": 12,
    "lat": -35.33902904999999,
    "lng": 149.15523332169712
  },
  {
    "name": "Ngunnawal",
    "value": 3,
    "lat": -35.1727896,
    "lng": 149.1114681
  },
  {
    "name": "Nicholls",
    "value": 11,
    "lat": -35.1871606,
    "lng": 149.0964814
  },
  {
    "name": "O'Connor",
    "value": 10,
    "lat": -35.2566001,
    "lng": 149.1155972
  },
  {
    "name": "O'malley",
    "value": 1,
    "lat": -35.3513599,
    "lng": 149.1106871
  },
  {
    "name": "Oaks Estate",
    "value": 3,
    "lat": -35.3400574,
    "lng": 149.2281788
  },
  {
    "name": "Paddys River",
    "value": 1,
    "lat": -35.4276826,
    "lng": 148.9765603
  },
  {
    "name": "Page",
    "value": 2,
    "lat": -35.2385472,
    "lng": 149.0499405
  },
  {
    "name": "Palmerston",
    "value": 1,
    "lat": -35.1944606,
    "lng": 149.1194145
  },
  {
    "name": "Parkes",
    "value": 42,
    "lat": -35.29652355,
    "lng": 149.12957364767345
  },
  {
    "name": "Parkwood",
    "value": 1,
    "lat": -35.204978,
    "lng": 148.9894379
  },
  {
    "name": "Phillip",
    "value": 12,
    "lat": -35.3470436,
    "lng": 149.091009
  },
  {
    "name": "Pialligo",
    "value": 4,
    "lat": -35.3114785,
    "lng": 149.1831218
  },
  {
    "name": "Queanbeyan",
    "value": 8,
    "lat": -35.34417446977617,
    "lng": 149.20971364376848
  },
  {
    "name": "Questacon",
    "value": 1,
    "lat": -35.2985062,
    "lng": 149.13125482001607
  },
  {
    "name": "Red Hill",
    "value": 6,
    "lat": -35.3334376,
    "lng": 149.1205858
  },
  {
    "name": "Reid",
    "value": 2,
    "lat": -35.2838529,
    "lng": 149.1454343
  },
  {
    "name": "Richardson",
    "value": 1,
    "lat": -35.4279022,
    "lng": 149.1139473
  },
  {
    "name": "Rivett",
    "value": 2,
    "lat": -35.3470708,
    "lng": 149.0379828
  },
  {
    "name": "Royalla",
    "value": 1,
    "lat": -35.51586106735823,
    "lng": 149.14765005159165
  },
  {
    "name": "Russell",
    "value": 4,
    "lat": -35.2975684,
    "lng": 149.1516924
  },
  {
    "name": "Spence",
    "value": 2,
    "lat": -35.1987316,
    "lng": 149.0643556
  },
  {
    "name": "Stirling",
    "value": 2,
    "lat": -35.3495843,
    "lng": 149.0493585
  },
  {
    "name": "Strathnairn",
    "value": 6,
    "lat": -35.2323902,
    "lng": 148.985554
  },
  {
    "name": "Symonston",
    "value": 1,
    "lat": -35.3488407,
    "lng": 149.1600894
  },
  {
    "name": "Taylor",
    "value": 8,
    "lat": -35.1468038,
    "lng": 149.1071989
  },
  {
    "name": "Tharwa",
    "value": 6,
    "lat": -35.50859385,
    "lng": 149.07047668936517
  },
  {
    "name": "Theodore",
    "value": 2,
    "lat": -35.4496107,
    "lng": 149.1197437
  },
  {
    "name": "Throsby",
    "value": 11,
    "lat": -35.1889539,
    "lng": 149.1617493
  },
  {
    "name": "Torrens",
    "value": 4,
    "lat": -35.37195,
    "lng": 149.0878797
  },
  {
    "name": "Tralee",
    "value": 2,
    "lat": -35.40181692286359,
    "lng": 149.1561394825565
  },
  {
    "name": "Tuggeranong",
    "value": 4,
    "lat": -35.4209771,
    "lng": 149.0921341
  },
  {
    "name": "Tumbarumba",
    "value": 1,
    "lat": -35.4883502,
    "lng": 149.0026942
  },
  {
    "name": "Turner",
    "value": 19,
    "lat": -35.2812742,
    "lng": 149.11720225021372
  },
  {
    "name": "Wagga Wagga",
    "value": 1,
    "lat": -35.3818466,
    "lng": 149.11084
  },
  {
    "name": "Wanniassa",
    "value": 2,
    "lat": -35.3976642,
    "lng": 149.0908045
  },
  {
    "name": "Waramanga",
    "value": 6,
    "lat": -35.3528151,
    "lng": 149.0622152
  },
  {
    "name": "Watson",
    "value": 11,
    "lat": -35.2348235,
    "lng": 149.1594458
  },
  {
    "name": "Weetangera",
    "value": 5,
    "lat": -35.2501136,
    "lng": 149.049737
  },
  {
    "name": "Weston",
    "value": 12,
    "lat": -35.343397,
    "lng": 149.0477964
  },
  {
    "name": "Whitlam",
    "value": 38,
    "lat": -35.2780956,
    "lng": 149.0363976
  },
  {
    "name": "Whitlam.",
    "value": 2,
    "lat": -35.2780956,
    "lng": 149.0363976
  },
  {
    "name": "Woden",
    "value": 9,
    "lat": -35.3498582,
    "lng": 149.0940482
  },
  {
    "name": "Wright",
    "value": 3,
    "lat": -35.3192644,
    "lng": 149.0336167
  },
  {
    "name": "Yarralumla",
    "value": 29,
    "lat": -35.3040411,
    "lng": 149.0986347
  },
  {
    "name": "Yass",
    "value": 1,
    "lat": -35.335210200000006,
    "lng": 149.2400396
  }
];
